// Shared service labels keep location pages and their structured data aligned.
export const LOCATION_SERVICES = [
    {
        title: "Taxi Service & Cab Booking",
        description: "Plan local pickups, station transfers and onward journeys with a driver. Share the pickup and drop details to confirm availability and the complete fare.",
    },
    {
        title: "Car Rental & Car Hire",
        description: "Compare cars and SUVs with a driver for your itinerary. Confirm the vehicle, hire duration, waiting time and permitted access before booking.",
    },
    {
        title: "Tempo Traveller on Hire / Rental",
        description: "Compare Traveller seating options for your group and luggage. Confirm vehicle suitability, pickup arrangements and route access for your travel dates.",
    },
    {
        title: "One Way Taxi & Round Trip",
        description: "Request a quote for a one-way transfer or a return journey. Include all stops, travel dates and any waiting or overnight requirements.",
    },
    {
        title: "Family Tour & Group Transportation",
        description: "Coordinate family outings and group travel with a shared pickup plan. Include passenger numbers, luggage and each stop when choosing a suitable vehicle.",
    },
    {
        title: "Tourist Sightseeing & Pilgrimage Tours",
        description: "Plan sightseeing and pilgrimage road transfers around permitted access and agreed meeting points. Confirm any entry, permits, guides or onward travel separately from vehicle hire.",
    },
];
